<template>
  <v-card class="mx-auto" width="256" tile color="#313942">
    <v-img width="120" aspect-ratio="3.5" contain class="mx-auto mt-10" src="@/assets/logo/main.svg"></v-img>
    <p class="text-center white--text mt-4 mb-2">관리자 페이지</p>
    <v-divider color="grey" class="mx-16"></v-divider>

    <p v-if="isAdminLoggedIn" class="white--text text-center mt-4 mb-0" style="line-height: 20px">
      {{ adminDisplayName }}<br />
      <span style="font-size: 12px">{{ adminUserType }} 접속중</span>
    </p>

    <div class="d-flex justify-center mt-2 mb-17px">
      <v-btn v-if="isAdminLoggedIn" color="grey lighten-1" x-small width="20" height="20" fab depressed class="mr-2">
        <v-icon size="12">mdi-cog-outline</v-icon>
      </v-btn>
      <v-btn v-if="isAdminLoggedIn" color="grey lighten-1" x-small width="20" height="20" fab depressed to="/admin/auth/logout">
        <v-icon size="12">mdi-logout</v-icon>
      </v-btn>
    </div>

    <!-- 메뉴 그룹 -->
    <v-list v-if="isAdminLoggedIn" nav dense color="#313942">
      <!-- 메뉴 -->
      <v-list-item v-for="(item, index) in menu.general" :key="index" :to="item.link" class="py-1 px-3" :class="$route.path == item.link ? 'primary' : ''">
        <!-- 아이콘 -->
        <v-list-item-icon>
          <v-icon color="white">{{ item.icon }}</v-icon>
        </v-list-item-icon>

        <!-- 제목 -->
        <v-list-item-content>
          <v-list-item-title class="white--text">{{ item.text }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-divider class="grey darken-1 mx-2 my-4"></v-divider>

    <!-- 관리자 전용 메뉴 그룹 -->
    <v-list v-if="isAdminLoggedIn && isAdminRole" nav dense color="#313942">
      <!-- 메뉴 -->
      <v-list-item v-for="(item, index) in menu.admin" :key="index" :to="item.link" class="py-1 px-3" :class="$route.path == item.link ? 'primary' : ''">
        <!-- 아이콘 -->
        <v-list-item-icon>
          <v-icon color="white">{{ item.icon }}</v-icon>
        </v-list-item-icon>

        <!-- 제목 -->
        <v-list-item-content>
          <v-list-item-title class="white--text">{{ item.text }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item href="https://admin.sela-castle.com/" target="_blank">
        <v-list-item-icon>
          <v-icon color="white">mdi-open-in-new</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="white--text">관리자 사진 보정 메뉴</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-card>
</template>
<script>
import { mapGetters, mapState } from "vuex"

export default {
  computed: {
    ...mapState(["lafia_user"]),
    ...mapGetters(["userType"]),

    // 관리자 로그인 상태 확인
    isAdminLoggedIn() {
      return this.lafia_user.is_logined && this.userType !== "user"
    },

    // 관리자 이름 표시
    adminDisplayName() {
      return this.$getUserDisplayName(this.lafia_user.name) || this.lafia_user.user_id
    },

    // 관리자 타입 표시
    adminUserType() {
      switch (this.userType) {
        case "admin":
          return "관리자"
        case "staff":
          return "메이커"
        default:
          return this.userType || ""
      }
    },

    // 관리자 권한 체크
    isAdminRole() {
      return this.userType === "admin"
    },
  },

  data: () => ({
    menu: {
      general: [
        {
          text: "라피아 예약 스케줄",
          icon: "mdi-clock-time-five-outline",
          link: "/admin/lafia_castle",
        },
        {
          text: "라피아 예약 등록",
          icon: "mdi-touch-text-outline",
          link: "/admin/lafia/reservation",
        },
        {
          text: "나의 스케줄",
          icon: "mdi-account-clock-outline",
          link: "/admin/my_schedule",
        },
        // {
        //   text: "라피아 운영 관리",
        //   icon: "mdi-touch-text-outline",
        //   link: "/admin/castle/onsite",
        // },
        {
          text: "회원 관리",
          icon: "mdi-account-box-outline",
          link: "/admin/user",
        },
        {
          text: "결제내역 관리",
          icon: "mdi-gift-outline",
          link: "/admin/payments",
        },
        {
          text: "해외 결제내역 관리",
          icon: "mdi-cash-marker",
          link: "/admin/payletter",
        },
        {
          text: "프로모션 관리",
          icon: "mdi-credit-card",
          link: "/admin/promotion",
        },
        {
          text: "옵션 상품 관리",
          icon: "mdi-package-variant",
          link: "/admin/option-products",
        },
        {
          text: "이벤트 페이지 관리",
          icon: "mdi-sticker-emoji",
          link: "/admin/event",
        },
        {
          text: "트래블러 관리",
          icon: "mdi-wallet-travel",
          link: "/admin/travelers",
        },

        {
          text: "컨셉 관리",
          icon: "mdi-camera-image",
          link: "/admin/concept",
        },
        {
          text: "컨셉부스 관리",
          icon: "mdi-castle",
          link: "/admin/sela-castle",
        },
        {
          text: "운영시간 설정",
          icon: "mdi-clock-outline",
          link: "/admin/operationTime",
        },
        {
          text: "라피아 캐슬 매출 관리",
          icon: "mdi-chart-box-outline",
          link: "/admin/stats/sale",
        },
        {
          text: "프로모션 매출 관리",
          icon: "mdi-chart-box-outline",
          link: "/admin/stats/promotionSale",
        },
        {
          text: "트래블러 매출 관리",
          icon: "mdi-chart-box-outline",
          link: "/admin/stats/travelerSale",
        },
        {
          text: "통계 관리",
          icon: "mdi-chart-bar",
          link: "/admin/stats",
        },
        // {
        //   text: "통계 관리(구)",
        //   icon: "mdi-chart-bar",
        //   link: "/admin/stats/old",
        // },

        {
          text: "매출 관리",
          icon: "mdi-chart-box-outline",
          link: "/admin/sale",
        },
        {
          text: "직원 관리",
          icon: "mdi-shield-lock-outline",
          link: "/admin/staff",
        },
        {
          text: "지점 관리",
          icon: "mdi-store",
          link: "/admin/branch",
        },
        {
          text: "이용약관 관리",
          icon: "mdi-note-text-outline",
          link: "/admin/rule",
        },
        {
          text: "개인정보처리방침 관리",
          icon: "mdi-security",
          link: "/admin/privacy",
        },
        {
          text: "오시는 길 관리",
          icon: "mdi-map-marker",
          link: "/admin/location",
        },
        {
          text: "주인공 모집 목록",
          icon: "mdi-account-star",
          link: "/admin/website_youtube_link",
        },
        {
          text: "공주무도회 신청 리스트",
          icon: "mdi-crown-outline",
          link: "/admin/budokai_list",
        },
      ],
      admin: [],
    },
  }),
}
</script>
